import { render, staticRenderFns } from "./sxStus.vue?vue&type=template&id=24c3c762&scoped=true"
import script from "./sxStus.vue?vue&type=script&lang=js"
export * from "./sxStus.vue?vue&type=script&lang=js"
import style0 from "./sxStus.vue?vue&type=style&index=0&id=24c3c762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c3c762",
  null
  
)

export default component.exports